import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { UserPermissionsProvider } from "./feature-module/UserPermissionsContext";
import { CallProvider } from "./feature-module/academic/examinations/CallContext";
import { InactivityProvider } from "./feature-module/academic/examinations/InactivityContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <UserPermissionsProvider>
        <CallProvider>
        <InactivityProvider>
          <BrowserRouter basename={base_path}>
            <ALLRoutes />
          </BrowserRouter>
          </InactivityProvider>
        </CallProvider>
      </UserPermissionsProvider>
    </Provider>
  </React.StrictMode>
);
